import { render, staticRenderFns } from "./legal_entities.vue?vue&type=template&id=790151ed&scoped=true"
import script from "./legal_entities.vue?vue&type=script&lang=js"
export * from "./legal_entities.vue?vue&type=script&lang=js"
import style0 from "./legal_entities.vue?vue&type=style&index=0&id=790151ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790151ed",
  null
  
)

/* custom blocks */
import block0 from "./legal_entities.vue?vue&type=custom&index=0&blockType=upload-image"
if (typeof block0 === 'function') block0(component)

export default component.exports